<template>
  <div class="backGround">
    <div class="logoClass">
      <img src="logo.jpg" style="height: 100%;  border-radius: 10px;"/>
    </div>
    <ShadowInfo/>
  </div>
</template>

<script>
import ShadowInfo from './shadowInfo.vue';
export default {
    components: {
        ShadowInfo
    }
};
</script>

<style scoped>
.backGround {
  overflow: hidden;
  background-image: url("/public/bannerBack.jpg");
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding-right: 33vh;
}

.logoClass {
  position: absolute;
  left: 360px;
  top: 36px;
  width: 280px;
  height: 72px;
  opacity: 1;
  /* background: rgba(255, 138, 138, 1); */
}
</style>